const js1 = `
'use strict';

let a = 1
let b = 2

function add(a, b) {
    return a + b
}

add(a, b)
 `
const js2 = `
&lt;!-- 不建议 -->
if(a==1 && b==2){
    ...
}else{
    ...
}

&lt;!-- 建议 -->
if (a == 1 && b == 2) {
    ...
} else {
    ...
}

&lt;!-- 不建议 -->
let arr = [1,2,3]
let obj = {a:1,b:2}

&lt;!-- 建议 -->
let arr = [1, 2, 3]
let obj = { a: 1, b: 2 }

&lt;!-- 不建议 -->
let obj = {
    a: 1,
    b: 2,
}

&lt;!-- 建议，对象的最后一项不要加逗号，因为IE会报错 -->
let obj = {
    a: 1,
    b: 2
}
 `

export default {
    js1,
    js2
}